export const Type = {
	eContract: 'electronic_employment_contracts',
	eAdContract: 'e_ad_contract',
	eTermContract: 'e_term_contract',
}
